import { openErrorDialog, } from 'console/dialogs/error/redux/actions';
import { getAPIErrorMessage } from 'api';
export const load_alien_apps_urls = (yandex_url, google_url) => ({
    type: 'LOAD_ALIEN_APPS_URLS',
    yandex_disk_app: yandex_url,
    google_disk_app: google_url,
});
export const loadAlienAppsUrls = () => async (dispatch, getState, { api }) => {
    try {
        const response = await api.get_alien_app_urls();
        dispatch(load_alien_apps_urls(response.content.yandex, response.content.google));
    }
    catch (error) {
        dispatch(openErrorDialog({
            error_ui: getAPIErrorMessage(error, 'Сервис в данный момент не доступен'),
            error,
        }));
    }
};
export const AlienAppsUrlsReducer = (state = { yandex: undefined, google: undefined }, action) => {
    switch (action.type) {
        case 'LOAD_ALIEN_APPS_URLS':
            return {
                ...state,
                yandex: action.yandex_disk_app,
                google: action.google_disk_app,
            };
        default:
            return state;
    }
};
